import { useEffect, useState } from 'react'

type Device = 'mobile' | 'tablet' | 'desktop'

const getDevice = (): Device => {
  if (typeof window === 'undefined') {
    return 'mobile'
  }

  if (window.innerWidth < 768) {
    return 'mobile'
  }

  if (window.innerWidth < 1024) {
    return 'tablet'
  }

  return 'desktop'
}

export const useResponsiveEnvironment = () => {
  const [device, setDevice] = useState<Device>('mobile')

  useEffect(() => {
    const updateDevice = () => {
      const current = getDevice()
      setDevice(current)
    }

    updateDevice()
    window.addEventListener('resize', updateDevice)
    return () => window.removeEventListener('resize', updateDevice)
  }, [])

  return {
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
    isDesktop: device === 'desktop',
  }
}
